import { Form, Formik } from 'formik';
import { useState } from 'react';

import useAddEditCompanyFormConfig, {
  type CompanyFormValues,
  type CompanyInput,
} from './useAddEditCompanyFormConfig';

import AddEditCompanyFormBody from './AddEditCompanyFormBody';
import ModalFooter from '@/shared/components/2.0/forms/ModalFooter';

type Props = {
  company?: CompanyInput;
  isContractor?: boolean;
  isSubmitting?: boolean;
  minified?: boolean;
  onCancel: () => void;
  onSubmit: (values: CompanyFormValues) => void | Promise<void>;
};

const AddEditCompanyForm: React.FC<Props> = ({
  company,
  isContractor = false,
  isSubmitting = false,
  minified = false,
  onCancel,
  onSubmit,
}) => {
  const [hasManualError, setHasManualError] = useState(false);

  const { baseValidationSchema, expandedValidationSchema, initialValues } =
    useAddEditCompanyFormConfig(company, {
      isContractor,
      minified,
    });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={minified ? baseValidationSchema : expandedValidationSchema}
      onSubmit={(values) => {
        if (hasManualError) return;
        return onSubmit(values);
      }}
    >
      {(formik) => (
        <Form className="mt-3">
          <AddEditCompanyFormBody minified={minified} setHasManualError={setHasManualError} />
          <ModalFooter
            isSubmitting={formik.isSubmitting || isSubmitting}
            submitButtonType="button"
            onCancel={onCancel}
            onSubmit={() => {
              if (hasManualError) return;
              return onSubmit(formik.values);
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddEditCompanyForm;
